import React, { useState, useEffect, useImperativeHandle } from 'react'
import moment from 'moment'
import { Calendar } from 'primereact/calendar'
import { InputSwitch } from 'primereact/inputswitch'
import { Checkbox } from 'primereact/checkbox'
import { SelectButton } from 'primereact/selectbutton'

const TopFilters = React.forwardRef((props, ref) => {
	
	const { DS } = props
	
	// map switch
	const [showMap, setShowMap] = useState(DS.filters.showMap)
	useEffect(() => {
		DS.setters.setFilters(Object.assign({}, DS.filters, {showMap}))
	}, [showMap])
	
	// dates bound
	const MIN_DATE = moment("2023-01-01").toDate()
	const [date1, setDate1] = useState(null)
	const [date2, setDate2] = useState(null)
	const [unrestrictedMode, setUnrestrictedMode] = useState(false)
	const [unresolvedMode, setUnresolvedMode] = useState(true)
	const periodOptions = [...['Оперативный', 'Ежедневный', 'Еженедельный', 'За период'], ...(DS?.userSettings?.mapOptions?.specobjects ? ['Спецобъекты'] : []) ]
	const [period, setPeriod] = useState(periodOptions[0])
	
	const changeDate1 = (e) => {
		setDate1(e.value)
		setPeriod(periodOptions[3])
		DS.loadEvents([e.value, date2], period, unrestrictedMode, unresolvedMode)
	}
	const changeDate2 = (e) => {
		setDate2(e.value)
		setPeriod(periodOptions[3])
		DS.loadEvents([date1, e.value], period, unrestrictedMode, unresolvedMode)
	}
	useEffect(() => {
		DS.loadEvents([date1, date2], period, unrestrictedMode, unresolvedMode)
	}, [unrestrictedMode, unresolvedMode])
	useEffect(() => {
		DS.setters.setFilters(Object.assign({}, DS.filters, {date1, date2, period}))
	}, [date1, date2, unrestrictedMode, unresolvedMode])
	useEffect(() => {
		let _date1 = date1
		let _date2 = date2
		if (period === periodOptions[0]) {
			_date1 = moment().toDate()
			_date2 = null
		} else if (period === periodOptions[1]) {
			//_date1 = moment().startOf('day').subtract(1, 'day').add(9, 'hours')
			_date1 = moment().subtract(1, 'day').toDate()
			//_date2 = moment().startOf('day').add(9, 'hours')
			_date2 = moment().subtract(1, 'day').toDate()
		} else if (period === periodOptions[2]) {
			_date1 = moment().subtract(7, 'day').toDate()
			_date2 = moment().subtract(1, 'day').toDate()
		} else {
			DS.setters.setFilters(Object.assign({}, DS.filters, {period}))
		}
		setDate1(_date1)
		setDate2(_date2)
		DS.loadEvents([_date1, _date2], period, unrestrictedMode, unresolvedMode, period === 'Спецобъекты')
	}, [period])

	useImperativeHandle(ref, () => ({
		showMap() {
			setShowMap(true)
		},
		reloadData() {
			DS.loadEvents([date1, date2], period, unrestrictedMode, unresolvedMode, period === 'Спецобъекты')
		},
	}))
	
	return <>
		<div id="top-filters-bar" className="flex align-items-center flex-wrap" onDoubleClick={() => document.getElementById('top-filters-bar').scrollIntoView({behavior: 'smooth'})}>
			<div className="m-3">Карта</div>
			<InputSwitch checked={showMap} onChange={e => setShowMap(e.value)} />
			
			<SelectButton className="ml-5" value={period} options={periodOptions} onChange={e => e.value && setPeriod(e.value)} />
			
			{ period !== 'Спецобъекты' &&
			<>
				<div className="ml-5">{'Период:'}</div>
				<div className="ml-2 mr-1">{'с'}</div>
				<Calendar className="m-1" value={date1} onChange={changeDate1} dateFormat="dd-mm-yy" minDate={MIN_DATE}/>
				<div className="ml-2 mr-1">{'по'}</div>
				<Calendar className="m-1" value={date2} onChange={changeDate2} dateFormat="dd-mm-yy" minDate={MIN_DATE}/>
				
				{DS?.userSettings?.mapOptions?.unrestricted && <>
					<Checkbox inputId="not-for-tablet-only" className="ml-5 mr-2" checked={unrestrictedMode} onChange={(e) => setUnrestrictedMode(e.checked)} />
					<label htmlFor="not-for-tablet-only" className="">{'Все происшествия'}</label>
				</>}
				{DS?.userSettings?.mapOptions?.unresolved && <>
					<Checkbox inputId="not-resolved" className="ml-5 mr-2" checked={unresolvedMode} onChange={(e) => setUnresolvedMode(e.checked)} />
					<label htmlFor="not-resolved" className="">{'Незавершенные'}</label>
				</>}
				
			</>}
		</div>
	</>
	
})

export default TopFilters
